import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, where, getDocs, documentId } from 'firebase/firestore';
import PageHeader from '../components/PageHeader';
import AnimatedSection from '../components/AnimatedSection';
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Counter from "yet-another-react-lightbox/plugins/counter";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/counter.css";
import { FaArrowLeft, FaHeart, FaTrash } from 'react-icons/fa';
import '../components/styles.css';

const GaleriFavoritPage = () => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [imageIndex, setImageIndex] = useState(0);

    useEffect(() => {
        const fetchFavoriteImages = async () => {
            setLoading(true);
            setError(null);
            try {
                const favoriteIds = JSON.parse(localStorage.getItem('gallery_favorites') || '[]');

                if (favoriteIds.length === 0) {
                    setImages([]);
                    setLoading(false);
                    return;
                }

                // Firestore 'in' query limited to 30 items.
                // For now, we take the last 30 favorites (newest first).
                const idsToFetch = favoriteIds.slice(-30);

                const imagesQuery = query(
                    collection(db, 'galeri'),
                    where(documentId(), 'in', idsToFetch)
                );

                const imagesSnapshot = await getDocs(imagesQuery);
                const fetchedImages = imagesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                // Sort based on the order in neighborIds to maintain user's favorite order
                fetchedImages.sort((a, b) => favoriteIds.indexOf(b.id) - favoriteIds.indexOf(a.id));

                setImages(fetchedImages);
            } catch (err) {
                console.error("Error fetching favorites: ", err);
                setError("Gagal memuat foto favorit.");
            } finally {
                setLoading(false);
            }
        };

        fetchFavoriteImages();
    }, []);

    const clearAllFavorites = () => {
        if (window.confirm("Hapus semua foto dari daftar favorit?")) {
            localStorage.setItem('gallery_favorites', '[]');
            setImages([]);
        }
    };

    const openLightbox = (index) => {
        setImageIndex(index);
        setLightboxOpen(true);
    };

    const GalleryImage = ({ image, index }) => {
        const [loaded, setLoaded] = useState(false);
        return (
            <div className="gallery-item" onClick={() => openLightbox(index)}>
                <img
                    src={image.url}
                    alt={image.title || 'Galeri Sekolah'}
                    loading="lazy"
                    className={`img-fade-in ${loaded ? 'loaded' : ''}`}
                    onLoad={() => setLoaded(true)}
                />
                <div className="gallery-item-caption">
                    <p>{image.title || 'Galeri Sekolah'}</p>
                    <span className="gallery-item-category" style={{ fontSize: '0.75rem', opacity: 0.8 }}>{image.category}</span>
                </div>
            </div>
        );
    };

    return (
        <>
            <PageHeader title="Foto Favorit Saya" subtitle="Kumpulan foto yang Anda tandai di galeri." />
            <AnimatedSection>
                <section className="section">
                    <div className="container">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '40px', flexWrap: 'wrap', gap: '15px' }}>
                            <Link to="/galeri" className="btn-premium btn-premium-outline">
                                <FaArrowLeft /> <span>Kembali ke Galeri</span>
                            </Link>
                            {images.length > 0 && (
                                <button
                                    className="btn-premium btn-premium-outline"
                                    onClick={clearAllFavorites}
                                    style={{ color: '#ff4757', borderColor: '#ff4757' }}
                                >
                                    <FaTrash /> Hapus Semua
                                </button>
                            )}
                        </div>

                        {loading ? (
                            <div className="gallery-grid">
                                {[...Array(8)].map((_, i) => (
                                    <div key={i} className="gallery-item-skeleton skeleton"></div>
                                ))}
                            </div>
                        ) : error ? (
                            <p className="error-message">{error}</p>
                        ) : images.length > 0 ? (
                            <div className="gallery-grid">
                                {images.map((image, index) => (
                                    <GalleryImage key={image.id} image={image} index={index} />
                                ))}
                            </div>
                        ) : (
                            <div style={{ textAlign: 'center', padding: '80px 0', color: '#666' }}>
                                <FaHeart style={{ fontSize: '4rem', marginBottom: '20px', color: '#eee' }} />
                                <h3>Belum ada foto favorit.</h3>
                                <p>Klik ikon hati pada foto di galeri untuk menyimpannya di sini.</p>
                                <div style={{ marginTop: '30px' }}>
                                    <Link to="/galeri" className="btn-hero">Jelajahi Galeri</Link>
                                </div>
                            </div>
                        )}
                    </div>
                </section>
            </AnimatedSection>

            <Lightbox
                open={lightboxOpen}
                close={() => setLightboxOpen(false)}
                slides={images.map(img => ({ src: img.url, title: img.title, description: img.description }))}
                index={imageIndex}
                plugins={[Captions, Zoom, Thumbnails, Fullscreen, Counter]}
                click={(api) => api.toggleControls()}
                zoom={{ scrollToZoom: true, maxZoomPixelRatio: 5 }}
                thumbnails={{ position: "bottom", width: 80, height: 60, border: 1, borderRadius: 4, padding: 4, gap: 16, showToggle: true }}
                counter={{ container: { style: { top: "unset", bottom: 0 } } }}
                animation={{ zoom: 500 }}
            />
        </>
    );
};

export default GaleriFavoritPage;
